import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./styles/index.scss";
import { CDN_URL } from "./config";
import { pushLink, replaceLink } from "./libs/utils";

Vue.prototype.$cdnUrl = CDN_URL;
Vue.prototype.$pushLink = pushLink;
Vue.prototype.$replaceLink = replaceLink;

Vue.config.productionTip = false

// import vConsole from "vconsole";
// new vConsole();

require("./libs/rem.js");
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
